import React from 'react'
import { Route, Switch } from 'react-router'
import ReportCostCenterCost from './ReportCostCenterCost'

const Components = props => (
    <Switch>
        <Route exact path={`${props.match.url}/:year?`} component={ReportCostCenterCost} />
    </Switch>
)

export default Components
